import { createSelector } from '@reduxjs/toolkit';
const selectComments = state => state.comments;

export const selectVideoComments = createSelector(
  selectComments,
  ({ comments }) => comments
);

export const selectCommentBuckets = createSelector(
  selectComments,
  comments => comments.comment_buckets
);

export const selectCommentReplyCount = createSelector(
  selectComments,
  comments => comments.comment_reply_count
);
